import React, { forwardRef } from "react";
import "./FormikInput.scss";
import { Field, ErrorMessage } from "formik";

const FormikInput = forwardRef(
  (
    {
      id,
      label,
      name,
      touched,
      containerClass = "",
      error,
      classChange = false,
      type = "text",
      ...rest
    },
    ref
  ) => {
    return (
      <div className={`${classChange ? "" : " formikInput"} ${containerClass} `}>
        {label && <label htmlFor={id}>{label}</label>}
        <Field
          name={name}
          ref={ref}
          type={type}
          id={id}
          className={error && touched[id] ? "formikInput_error" : null}
          {...rest}
        />
        <ErrorMessage name={name} component="span" className="error" />
      </div>
    );
  }
);

export default FormikInput;
